import { isEmpty as isHtmlEmpty } from '@paintscout/util/util'
import type { PresentationIsEmptyProps } from '../../'
import { isPreviewQuote } from './getSampleEstimator'

export default function isEmpty({ estimator, quote }: PresentationIsEmptyProps) {
  // The sample quote used to preview a template has no estimator; keep the
  // block so it can render its dummy estimator instead of vanishing.
  if (isPreviewQuote(quote)) {
    return false
  }

  const description = estimator?.description ?? ''
  const hasContent = description && !isHtmlEmpty(description)

  if (!estimator?.image && !hasContent) {
    return true
  }

  return false
}
